<template>
  <div class="article-list-container">
    <base-title-bar-scroll-page ref="container" :back="true" title="科普园地" @onBackClick="goBack">
      <!-- 分类标签导航 -->
      <div class="category-tabs-wrapper">
        <van-tabs
          v-model="activeCategory"
          @change="onCategoryChange"
          swipeable
          animated
          line-width="30px"
          line-height="3px"
          color="#5CB8E6"
          title-active-color="#5CB8E6"
          title-inactive-color="#666"
        >
          <van-tab
            v-for="category in categories"
            :key="category.key"
            :title="category.label"
            :name="category.key"
          />
        </van-tabs>
      </div>

      <!-- 文章列表 -->
      <div class="article-list" style="padding: 8px 16px;">
        <van-skeleton :row="3" :loading="loading" v-for="i in 3" :key="'skeleton-' + i" v-if="loading">
          <template #template>
            <div class="skeleton-item">
              <div class="skeleton-title"></div>
              <div class="skeleton-content"></div>
            </div>
          </template>
        </van-skeleton>

        <template v-if="!loading">
          <div class="article-card"
               v-for="article in filteredArticles"
               :key="article.id"
               @click="goToDetail(article.id, article.category)">
            <div class="article-image" v-if="article.image">
              <img :src="article.image" alt="文章封面">
            </div>
            <div class="article-content">
              <h3 class="article-title">{{ article.title }}</h3>
              <p class="article-summary">{{ article.summary }}</p>
              <div class="article-meta">
                <span class="article-category">{{ getCategoryLabel(article.category) }}</span>
                <span class="article-date">{{ article.date }}</span>
              </div>
            </div>
          </div>

          <div class="empty-state" v-if="!loading && filteredArticles.length === 0">
            <van-empty image="search" description="暂无文章" />
          </div>
        </template>
      </div>
    </base-title-bar-scroll-page>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import { Skeleton, Empty, Toast, Tab, Tabs } from 'vant'
import { categories, articlesList } from './articlesData'
import SpineConfigDao from '@/h5/doucan/network/SpineConfigDao'

export default {
  name: 'ShunyiArticleListPage',
  components: {
    BaseTitleBarScrollPage,
    'van-skeleton': Skeleton,
    'van-empty': Empty,
    'van-tab': Tab,
    'van-tabs': Tabs
  },
  data () {
    return {
      loading: true,
      activeCategory: 'basic_knowledge', // 默认选中第一个分类
      // 分类列表（从共享数据导入）
      categories: categories,
      // 所有文章列表（从共享数据导入）
      articleList: articlesList
    }
  },
  computed: {
    // 根据选中的分类过滤文章
    filteredArticles () {
      if (!this.activeCategory) {
        return this.articleList
      }
      return this.articleList.filter(article => article.category === this.activeCategory)
    }
  },
  async created () {
    const category = this.$route.query.category
    if (category) {
      this.activeCategory = category
    }
    await this.loadSpineCategories()
    this.fetchArticleList()
  },
  mounted () {
    this.hideLoading()
  },
  methods: {
    hideLoading () {
      this.$refs.container.stopLoading()
    },
    async loadSpineCategories () {
      try {
        const config = await SpineConfigDao.load()
        if (config.sciencePopularizationList && config.sciencePopularizationList.length > 0) {
          this.categories = config.sciencePopularizationList.map(item => ({
            key: item.category,
            label: item.label,
            categoryId: item.categoryId || null,
            articleId: item.articleId || ''
          })).filter(item => item.key)
        }
      } catch (error) {
        console.warn('加载脊柱侧弯分类配置失败，使用本地分类', error)
      }
    },
    async fetchArticleList () {
      try {
        this.loading = true
        const category = this.categories.find(cat => cat.key === this.activeCategory)
        const routeCategoryId = this.$route.query.categoryId
        const categoryId = routeCategoryId || (category && category.categoryId)
        if (categoryId) {
          const { data: resp } = await this.$http.get('/ruYuanXuanJiao/articles', {
            params: { categoryId, page: 1, pageSize: 100 }
          })
          if (resp && resp.code === 200 && resp.data && resp.data.data) {
            this.articleList = resp.data.data.map(article => ({
              id: article.id,
              title: article.title,
              summary: article.brief || article.content || '',
              category: this.activeCategory,
              categoryLabel: this.getCategoryLabel(this.activeCategory),
              date: this.formatDate(article.createDate),
              image: '',
              raw: article
            }))
            this.loading = false
            return
          }
        }
        this.articleList = articlesList
      } catch (error) {
        console.error('获取文章列表失败:', error)
        Toast('获取文章列表失败，已显示默认内容')
        this.articleList = articlesList
      } finally {
        this.loading = false
      }
    },
    // 分类切换事件
    onCategoryChange (categoryKey) {
      console.log('切换到分类:', categoryKey)
      this.activeCategory = categoryKey
      this.fetchArticleList()
    },
    // 获取分类标签名称
    getCategoryLabel (categoryKey) {
      const category = this.categories.find(cat => cat.key === categoryKey)
      return category ? category.label : categoryKey
    },
    formatDate (value) {
      if (!value) return ''
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value).slice(0, 10)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    // 返回上一页
    goBack () {
      this.$router.back()
    },
    // 跳转到文章详情页
    goToDetail (id, category) {
      this.$router.push({
        path: '/shunyi/article/detail',
        query: {
          id,
          category,
          categoryId: (this.categories.find(cat => cat.key === category) || {}).categoryId || ''
        }
      })
    }
  }
}
</script>

<style scoped>
.article-list-container {
  background: #ffffff;
  min-height: 100vh;
}

/* 分类标签导航样式 */
.category-tabs-wrapper {
  background: white;
  padding: 0 !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 99;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 覆盖vant tabs样式 */
:deep(.van-tabs__wrap) {
  padding: 0 0;
}

:deep(.van-tab) {
  font-size: 14px;
  font-weight: 500;
  padding: 0 12px;
}

:deep(.van-tabs__line) {
  background: linear-gradient(90deg, #5CB8E6, #4A9FD8);
  border-radius: 3px;
}

/* 文章列表区域 */
.article-list {
  padding: 16px;
  min-height: calc(100vh - 150px);
}

/* 文章卡片 */
.article-card {
  background: white;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.article-card:active {
  transform: scale(0.98);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.article-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
  background: #f0f0f0;
}

.article-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.article-card:active .article-image img {
  transform: scale(1.05);
}

.article-content {
  padding: 16px;
}

.article-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-summary {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 12px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.article-category {
  background: linear-gradient(135deg, #5CB8E6, #4A9FD8);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(92, 184, 230, 0.3);
}

.article-date {
  color: #999;
  font-size: 12px;
}

/* 骨架屏样式 */
.skeleton-item {
  background: white;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.skeleton-title {
  height: 20px;
  margin-bottom: 12px;
  background: linear-gradient(90deg, #f2f3f5 25%, #e6e8eb 50%, #f2f3f5 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 4px;
  width: 80%;
}

.skeleton-content {
  height: 80px;
  background: linear-gradient(90deg, #f2f3f5 25%, #e6e8eb 50%, #f2f3f5 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 空状态 */
.empty-state {
  padding: 80px 0;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .article-list {
    padding: 12px;
  }

  .article-card {
    margin-bottom: 12px;
    border-radius: 12px;
  }

  .article-content {
    padding: 12px;
  }

  .article-title {
    font-size: 16px;
  }

  .article-summary {
    font-size: 13px;
  }

  .article-image {
    height: 160px;
  }
}

@media (min-width: 414px) {
  .article-image {
    height: 200px;
  }

  .article-title {
    font-size: 18px;
  }
}
</style>
